import FormItemContainerControl from './FormItemContainerControl';
import CmdTypeActions from '../../actions/CmdTypeActions';


export default class FormItemTabPageControl extends FormItemContainerControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemTabPageControl";
		
	}

	getStyle()
	{
		let layout = this.xml.Properties.Layout.Value;
		let parentLayout = this.parentXML.Properties.Layout.Value;
		let _flexDirection = (layout=="horizontal"?"row":"column");
		let style = {
			flexDirection:_flexDirection,
			alignItems:"flex-start",
			flex:'none'
	    };
	    style["display"] = this.props.visible?"flex":"none";
	    //chrome浏览器在某一父节点没有采用百分比的情况下 子节点设置百分比无效无效 
	    //所以采用flex布局
	   	//style["height"] = "100%";
	   	style["flexGrow"] = 100;
	   	
	   	style["overflow"] = 'auto';
		return style;
	}

	setControlLabelCmd(value)
	{
		this._cmdLabel = value;
		CmdTypeActions.updateControlLabel(this.xml.name,value,this.module.instanceUUId);
	}
}



// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemTabPageControl.js